// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2NAMN","alert":"SettungsInbox_alert__3ry9B"};